import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import CLIENT_VERSION from '../../constants/Version';
import "./Menu.css";

// ------------------------------
// メニュー定義（外部で管理しやすい）
// ------------------------------
const MENU_ITEMS = [
    { id: 1, label: "管理者マスタ", path: "/admin-list" },
    { id: 2, label: "ユーザーマスタ", path: "/user-list" },
    { id: 3, label: "ログ表示", path: "/logs-view" },
];

const SideMenu = React.memo(({fetchSystemInfo, systemInfo}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const isInitialRender = useRef(true);

    useEffect(() => {
        let accessToken = localStorage.getItem('accessToken');
        const refreshToken = localStorage.getItem('refreshToken');

        if (accessToken && refreshToken) {
            // Call fetchSystemInfo on the first render
            if (isInitialRender.current) {
                fetchSystemInfo();
                isInitialRender.current = false;
            }
        }

    }, [fetchSystemInfo]);

    // メニューの単一行コンポーネント
    const MenuItem = ({ label, path, isActive }) => {
        return (
            <button
                className={`list-group-item-custom${isActive ? " active" : ""}`}
                onClick={() => navigate(path, { state: { reloadAt: Date.now() } })}
            >
                {label}
            </button>
        );
    };

    return (
        <div className="ajax-sidemenu">
            <div className="lay-sidemenu">
                <div className="lay-sidemenu-wrap">
                    <div className="side-menu-system-title">
                        発番システム管理画面
                    </div>

                    {/* MENU LIST */}
                    <div className="side-menu-list">
                        {MENU_ITEMS.map(({ id, label, path }) => {
                            const isActive = location.pathname.startsWith(path);
                            return (
                                <MenuItem
                                    key={id}
                                    label={label}
                                    path={path}
                                    isActive={isActive}
                                />
                            );
                        })}
                    </div>

                    {/* FOOTER */}
                    <div className="lay-sidemenu-footer" style={{ marginTop: "auto" }}>
                        <div className="lay-sidemenu__copyright">
                            <img
                                src="/img/common/navi/copyright.png"
                                alt="Copyright"
                            />
                        </div>
                        <div className="lay-bottom__title">
                            <div className="footer-version">
                                <div>Version {CLIENT_VERSION}</div>
                                <span>&nbsp;&mdash;&nbsp;</span>
                                {systemInfo?.version && (
                                    <div>API Version {systemInfo.version}</div>
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
});

SideMenu.displayName = "SideMenu";    // fix eslint(react/display-name)

export default SideMenu;
